import axios from "axios";

export const getAllPanelistByPanelId = async (searchText = '', pageNumber = 1, pageSize = 200) => {
  try {
    const res = await axios.get(
      `/api/user/getAllPanelistByPanelId?searchText=${searchText}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getPanelistById = async (panelistId) => {
  try {
    const res = await axios.get(
      `/api/systemUser/getPanelistById?panelistId=${panelistId}`
    );
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getAllLanguage = async (panelistId) => {
  try {
    const res = await axios.get(`/api/systemUser/getLanguage`);
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getPanelistCountryLanguage = async (data) => {
  try {
    const res = await axios.post(`/api/panelist/getPanelistLanguage`, data);
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getActiveCountry = async (data) => {
  try {
    const res = await axios.get(`/api/systemUser/getActiveCountry`, data);
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getPanelistPointDetail = async (panelistId) => {
  try {
    const res = await axios.get(
      `/api/user/getPanelistPointDetail?panelistId=${panelistId}`
    );
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getSurveyParticipationPointsDetail = async (panelistId) => {
  try {
    const res = await axios.get(
      `/api/user/getSurveyParticipationPointsDetail?panelistId=${panelistId}`
    );
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getSurveyParticipationPoints = async (panelistId) => {
  try {
    const res = await axios.get(
      `/api/user/getSurveyParticipationPoints?panelistId=${panelistId}`);
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};
export const getPanelistPointSummary = async (panelistId) => {
  try {
    const res = await axios.get(
      `/api/user/getPanelistPointSummary?panelistId=${panelistId}`);
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getPanelistPointRedeemed = async (panelistId) => {
  try {
    const res = await axios.get(
      `/api/user/getPanelistPointRedeemed?panelistId=${panelistId}`);
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getPanelistPointRedeemedDetail = async (panelistId) => {
  try {
    const res = await axios.get(
      `/api/user/getPanelistPointRedeemedDetail?panelistId=${panelistId}`);
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const updatePanelist = async (data) => {
  try {
    const res = await axios.post(`/api/company/updatePanelist`, data);
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};
export const getPanelistDetails = async (panelistId) => {
  try {
    const res = await axios.get(
      `/api/company/getPanelistDetails?panelistId=${panelistId}`);
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};


export const getPanelistCategory = async (data) => {
  try {
    const res = await axios.get(
      `/api/company/getPanelistCategory`
    );
    return res;
  } catch (error) {
  }
};
export const updateW9Status = async (data) => {
  try {
    const res = await axios.post(
      `/api/company/updateW9Status`, data
    );
    return res;
  } catch (error) {
  }}
  
  export const getLoginHistory = async (panelistId) => {
    try {
      const res = await axios.get(
        `/api/Company/getLoginHistory?panelistId=${panelistId}`
      );
      return res;
    } catch (error) {
  }};

  export const getAnsweredQuestionPercentage = async (panelistId) => {
    try {
      const res = await axios.get(
        `/api/user/getAnsweredQuestionPercentage?panelistId=${panelistId}`
      );
      return res;
    } catch (error) {
  }};

  export const getPanelistActivity = async (panelistId) => {
    try {
      const res = await axios.get(
        `/api/Company/getPanelistActivity?panelistId=${panelistId}`
      );
      return res;
    } catch (error) {
  }};
